import { render } from "./StepBlocks.vue?vue&type=template&id=47e08232"
import script from "./StepBlocks.vue?vue&type=script&lang=js"
export * from "./StepBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/workflow-designer/nodes/StepBlocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47e08232"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47e08232', __exports__)) {
    api.reload('47e08232', __exports__)
  }
  
  module.hot.accept("./StepBlocks.vue?vue&type=template&id=47e08232", () => {
    api.rerender('47e08232', render)
  })

}


export default __exports__